import { Box, CircularProgress } from "@mui/material";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import ServiceSuspended from "../components/ServiceSuspended";
import { useAgenciaStore } from "../zustand/useAgenciaStore";
import { useAuthStore } from "../zustand/useAuthStore";

/**
 * Rutas accesibles aunque el servicio esté suspendido: dejan al Admin una vía
 * para revisar la configuración, cambiar su contraseña y cerrar sesión.
 */
const SUSPENSION_EXEMPT_PATHS = ["/settings", "/profile"];

export default function ProtectedRoute() {
  const { isAuthenticated } = useAuthStore();
  const { agencia, loading } = useAgenciaStore();
  const { pathname } = useLocation();

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  // Aún no sabemos si el servicio está activo: no mostrar el mensaje de suspensión.
  if (loading)
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );

  if (SUSPENSION_EXEMPT_PATHS.includes(pathname)) return <Outlet />;

  if (!agencia?.activo) return <ServiceSuspended />;

  return <Outlet />;
}
